import React, { useState } from 'react'
import PropTypes from 'prop-types'

const DowngradeAccountContext = React.createContext({})

const DowngradeAccountContextWrapper = ({ children }) => {
  const [domainsToKeep, setDomainsToKeep] = useState([])

  return (
    <DowngradeAccountContext.Provider
      value={{
        domainsToKeep,
        setDomainsToKeep
      }}
    >
      {children}
    </DowngradeAccountContext.Provider>
  )
}

DowngradeAccountContextWrapper.propTypes = {
  children: PropTypes.node.isRequired
}

export { DowngradeAccountContext }
export default DowngradeAccountContextWrapper
